import { useEffect } from "react";
import _get from "lodash/get";
import BannerCreateFrom from "components/Banner/CreateForm";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router";
import {
  updateBannerRequest,
  getBannerDetailRequest,
  resetBannerDetail,
} from "providers/BannerProvider/slice";
import "../BannerCreate/styles.less";

const BannerEdit = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { idBanner } = useParams();
  const bannerDetail = useSelector((state) =>
    _get(state, "banner.bannerDetail", { type: [] })
  );

  useEffect(() => {
    dispatch(getBannerDetailRequest({ idBanner }));
  }, [dispatch, idBanner]);

  const handleSubmit = (values) => {
    const submitValues = { ...values };
    delete submitValues.navigationType;

    dispatch(updateBannerRequest({ ...submitValues, idBanner })).then(() => {
      navigate(-1);
      dispatch(resetBannerDetail());
    });
  };

  return (
    <div className="banner-create-wrapper">
      <BannerCreateFrom
        initialValues={{
          ...bannerDetail,
          navigationType: [
            "HOME_SCREEN", "FONEHOUSE", "FONEHOUSE_LIST", "NEWS_LIST", "NEWS_DETAIL",
            "STORES", "GUIDE_CATEGORY", "SIM_CATEGORY_SCREEN", "TOURIST_CATEGORY_SCREEN",
            "VISA_CATEGORY_SCREEN", "JOBS_SCREEN", "MY_CART_SCREEN", "PRODUCT_DETAIl_SCREEN",
            "MANAGE_ORDERS_SCREEN", "SEARCH_SCREEN", "INSURANCE_SCREEN", "PURCHASE_SCREEN",
            "CHAT_WITH_VIEGO_AI_SCREEN", "VIEGO_WALLET_SCREEN", "CONTEST_DETAIL", "CREATE_POST",
            "COMMUNITY_SCREEN", "NOTIFICATION_SCREEN", "SETTINGS_SCREEN", "PURCHASING_PROCESS_SCREEN"
          ].includes(bannerDetail.url) ? "screen" : "url",
          image: { url: bannerDetail.image },
          type: bannerDetail.type || [],
        }}
        onSubmit={handleSubmit}
        isEditBanner
      />
    </div>
  );
};

export default BannerEdit;
